module.exports = __webpack_public_path__ + "static/media/draw-one-line.ce45de09.jpg";